module.exports = __webpack_public_path__ + "img/selected1-min.9a6129dc.png";